import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import {geListedCompanyList} from '../../request/index/listedCompany'
import {getToken} from '../../request/common'

export default {
    namespaced: true,
    state: {
        // 上市企业列表
        listToken: '',
        listKeyWord: '',
        pageNum: 1,
        listData: {},
        listHasUrlParam: false,
        listHasContent: false,
        listDataSate: true
    },
    mutations: {
        setList (state, payLoad) {
            state.listKeyWord = payLoad.kw
            state.pageNum = payLoad.pageNum
            state.listData = payLoad.data
        },
        setListKeyWord (state, kw) {
            state.listKeyWord = kw
        },
        setToken (state, token) {
            state.listToken = token
        },
        setListHasUrlParam (state, isOpen) {
            state.listHasUrlParam = isOpen
        },
        setListHasContent (state, isOpen) {
            state.listHasContent = isOpen
        },
        setListDataSate (state, isOpen) {
            state.listDataSate = isOpen
        }
    },
    actions: {
        // payLoad: kw, page
        getList (context, payLoad) {
            // 获取参数
            let listedSearchParams = {
                param: {keyword: payLoad.kw, page: payLoad.page},
                token: payLoad.token
            }
            // 请求接口
            return geListedCompanyList(listedSearchParams.param, listedSearchParams.token).then(res => {
                if (res.success) {
                    // 将列表信息和搜索值传入store (这个接口就算返回值是空格式也是正确的,载荷为res.data与searchKw)
                    const payLoad = {
                        kw: listedSearchParams.param.keyword,
                        pageNum: listedSearchParams.param.page,
                        data: res.data
                    }
                    context.commit('setList', payLoad)
                } else {
                    const payLoad = {
                        kw: listedSearchParams.param.keyword,
                        pageNum: listedSearchParams.param.page,
                        data: res.data
                    }
                    context.commit('setList', payLoad)
                    console.warn('获取上市企业列表失败')
                }
                return res
            })
        },
        getToken (context) {
            return getToken().then(res => {
                if (res.success) {
                    context.commit('setToken', res.data)
                }
                return res
            })
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/listedCompany.js